<template>
  <div class="card">
    <div class="img">
      <img :src="contentUrl + meditationOfDay.image" alt="">
    </div>

    <div class="card__content">
      <h3>{{meditationOfDay.title}}</h3>
      <p>{{meditationOfDay.readTime}}</p>

      <div class="card__action" @click="$router.push('/profile/meditations#meditation' + meditationId)">
        {{ $t("profile.home.startMeditation") }}
      </div>
    </div>
  </div>
</template>

<script>
import meditationsList from "./data/meditations.en.json";

export default {
  name: "day-article",

  inject: ['contentUrl'],

  props: ["date"],

  data() {
    return {
      meditationOfDay: {},
      currentDate: new Date(this.date),
      meditations: meditationsList,
    };
  },

  async created() {
    try {
      const localeData = await import(`./data/meditations.${this.$i18n.locale}.json`);
      this.meditations = localeData.default;
    } catch (e) {
      console.log(e);
    }
    this.meditationOfDay = this.getMeditationOfDay();
  },

  computed: {
    meditationId() {
      return Object.keys(this.meditations).indexOf(this.meditationOfDay.title);
    },
  },

  watch: {
    date(value) {
      this.currentDate = new Date(value);
      this.meditationOfDay = this.getMeditationOfDay();
    },
  },

  methods: {
    getMeditationOfDay() {
      const day = this.currentDate.getDate();
      const meditations = Object.keys(this.meditations);

      if (day > meditations.length - 1) {
        return this.meditations[meditations[day % meditations.length]];
      } else {
        return this.meditations[meditations[day]];
      }
    },
  },
}
</script>
